<template>
	<div class="location-box__btns">
		<Button
			v-if="showOrder"
			:text="$t('locations.orderButton')"
			type="button"
			level="primary"
			small
			@click="onOrder"
		/>
		<Button
			v-if="showReservation"
			:text="$t('locations.reserveButton')"
			type="button"
			level="primary"
			small
			@click="onReservation"
		/>
		<div
			v-if="isLunchPerMailActive"
			class="location-box__lunchmail"
		>
			<Button
				:href="$t('locations.lunchMailUrl', { id })"
				level="tertiary"
				:text="$t('locations.lunchMailButton')"
				arrow
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import htmlComponent from 'htmlcomponent'
import Button from '@/components/Button';

export default {
	components: {
		Button,
	},
	data() {
		return {
			id: this.$root.options.id,
			openingHours: this.$root.options.openingHours,
			reservationUrl: this.$root.options.reservationUrl,
			hasReservation: this.$root.options.hasReservation,
			hasIndining: this.$root.options.hasIndining,
			foratableRestaurantHash: this.$root.options.foratableRestaurantHash,
			code: this.$root.options.code,
			isLunchPerMailActive: this.$root.options.isLunchPerMailActive,
		};
	},
	computed: {
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		showReservation() {
			return this.hasFeature('FEATURE_RESERVATION') && this.hasReservation && !!this.foratableRestaurantHash;
		},
    showOrder() {
      return (this.hasFeature('FEATURE_ORDERBOX_DELIVERY') || this.hasFeature('FEATURE_ORDERBOX_TAKEAWAY')) && this.openingHours?.length
    }
	},
	methods: {
		onOrder() {
			htmlComponent.send('overlay:open', {type: 'overlay-orderbox', locationCode: this.code});
		},
		onIndining() {
			if (this.hasFeature('FEATURE_RESERVATION')) {
				this.$store.dispatch('redirect', { name: 'indining-restaurant', params: { code: this.code} })
			}
		},
		onReservation() {
			if (this.hasFeature('FEATURE_RESERVATION')) {
				this.$store.dispatch('redirect', { name: 'reservation-restaurant', params: { code: this.code} })
			}
		},
	}
}
</script>

<style>

</style>
